import React, { useState } from 'react';
import RecoverableImage from '../../features/images/RecoverableImage';
import { Link } from 'react-router-dom';
import { feedPath } from './feedPresentation';
import { feedListDate, feedThumbnail } from './feedListModel';
function FeedThumbnail({ uri }) {
  const [useOriginal, setUseOriginal] = useState(false);
  const thumbnail = feedThumbnail(uri);
  const usingThumbnail = thumbnail !== uri && !useOriginal;
  return (
    <RecoverableImage
      src={usingThumbnail ? thumbnail : uri}
      alt=""
      loading="lazy"
      onError={usingThumbnail ? () => setUseOriginal(true) : undefined}
    />
  );
}
export default function FeedListCard({ post, en, onOpen, scale = 1 }) {
  const excerpt = post.excerpt?.trim();
  const date = feedListDate(post.createdAt);
  return (
    <Link
      className="pp-feed-list-card"
      to={feedPath(post)}
      data-feed-id={post.id}
      onClick={onOpen}
      onPointerDown={() => {
        if (post.imageUrl) {
          const image = new Image();
          image.src = post.imageUrl;
        }
      }}
      aria-label={[
        post.title,
        excerpt,
        date,
        post.isSponsored ? (en ? 'Ad' : '광고') : null,
        post.isHidden ? (en ? 'Hidden' : '숨김') : null,
      ]
        .filter(Boolean)
        .join(', ')}
      style={{
        '--feed-card-scale': Math.min(scale, 1.5),
        '--feed-effect-height': `${Math.max(168, 108 * Math.min(scale, 1.5) + 38)}px`,
      }}
    >
      {post.imageUrl && <FeedThumbnail key={post.imageUrl} uri={post.imageUrl} />}
      <span className="pp-feed-list-effect" aria-hidden="true" />
      <span className="pp-feed-list-copy">
        <strong>{post.title}</strong>
        {excerpt && <span className="pp-feed-list-excerpt">{excerpt}</span>}
        <span className="pp-feed-list-date">
          <time>{date}</time>
          {post.isHidden && <span className="pp-feed-list-ad">{en ? 'Hidden' : '숨김'}</span>}
          {post.isSponsored && <span className="pp-feed-list-ad">{en ? 'Ad' : '광고'}</span>}
        </span>
      </span>
    </Link>
  );
}
